import { Content } from '../../types';

export const floatingMarketContent: Content = {
  title: 'שווקים ייחודיים בקרבת בנגקוק – חוויה אותנטית וייחודית',
  imageUrl: '/images/thailand/floating-market/floating-market-wide.jpeg',
  introduction:
    'שווקים בתאילנד, הינם חלק בלתי נפרד מחיי היום - יום ומהתרבות המקומית. הם מגוונים באופיים ומציעים חוויות ייחודיות במגוון רחב של סגנונות: שווקים רגילים, שווקים צפים, שווקים על מסילות רכבת, שווקים ליליים ושווקים מסורתיים. חלקם תיירותיים מאוד, בעוד אחרים שומרים על אופיים האותנטי.',
  sections: [
    {
      title: 'אודות הטיול המשולב',
      content:
        "אחד מטיולי היום הפופולריים ביותר מבנגקוק משלב ביקור בשלושה אתרים מיוחדים: השוק הצף, שוק הרכבת ושמורת הקופים השוחים. ניתן לבצע טיול זה כחלק מיציאה/חזרה יומית מ/ אל בנגקוק, כחלק מטיול לקנצ'נבורי או ביום טיול בדרך להואה הין.",
      type: 'text',
    },
    {
      title: 'השווקים הצפים המיוחדים',
      type: 'sub-headers',
      description:
        'השווקים הצפים מהווים אטרקציה ייחודית בתאילנד המציגה את אורח החיים המסורתי לאורך נתיבי המים. להלן השווקים הצפים הפופולריים ביותר בקרבת בנגקוק:',
      content: [
        {
          subtitle: 'השוק הצף דמנואן סאדואק (Damnoen Saduak)',
          text: '<strong>מיקום:</strong> מחוז Samut Songkhram, כ - 100 ק"מ מבנגקוק. <br /><strong>שעות פעילות:</strong> כל ימות השבוע, מהבוקר ועד הצהריים.\n<br />זהו השוק הצף המפורסם ביותר בתאילנד, המהווה מוקד משיכה לתיירים מכל העולם. השוק ממוקם על רשת של תעלות מים, כאשר במרכזו תעלה ראשית ממנה מסתעפות תעלות משניות. הביקור נעשה באמצעות סירות לונגטייל או סירות קטנות יותר, כשבין הסירות שטים רוכלים המציעים מגוון מוצרים, כולל פירות טרופיים טריים, ירקות, אוכל רחוב תאילנדי, קינוחים מסורתיים ומזכרות. לאורך התעלות ישנם גם דוכנים הממוקמים על היבשה. אמנם מדובר בשוק תיירותי לחלוטין ולא אותנטי, אך המראות הצבעוניים, האווירה התוססת והחוויה הייחודית הופכים אותו ליעד מומלץ מאוד.',
        },
        {
          subtitle: 'השוק הצף אמפאווה (Amphawa Floating Market)',
          text: '<strong>מיקום:</strong> מחוז Samut Songkhram, כ - 80 ק"מ מבנגקוק. <br /><strong>שעות פעילות:</strong> ימי שישי עד ראשון, משעות הצהריים ועד הלילה.\n<br />בניגוד לדמנואן סאדואק, השוק הצף באמפאווה הוא אותנטי יותר ומתוייר פחות. הוא מתרכז סביב התעלה המרכזית, כשלאורכה דוכנים וחנויות המציעים אוכל רחוב, פירות טריים, ירקות ומזכרות. חוויית השוק משלבת גם שייט בסירות המציעות למכירה פירות וארוחות תאילנדיות מסורתיות. שעות הפעילות הייחודיות של השוק, המתקיים גם בשעות הערב, מוסיפות לו אווירה מיוחדת ומאפשרות לחוות את תאילנד בצורה אותנטית יותר.',
        },
      ],
    },
    {
      title: 'אטרקציות ייחודיות נוספות באזור',
      type: 'sub-headers',
      description:
        'מלבד השווקים הצפים, האזור מציע מספר אטרקציות יוצאות דופן שמשתלבות היטב בטיול יום מבנגקוק:',
      content: [
        {
          subtitle:
            'שוק הרכבת מאקלונג (Talat Rom Hub – Maeklong Railway Market)',
          text: '<strong>מיקום:</strong> סמוך לתחנת Maeklong, מחוז Samut Songkhram. <br /><strong>שעות פעילות:</strong> מידי יום, הרכבת עוברת 8 פעמים ביום.\n<br />זהו אחד השווקים המיוחדים ביותר בעולם, הממוקם ישירות על מסילת רכבת פעילה. כאשר הרכבת מתקרבת, הרוכלים מקפלים במהירות את הסוככים והדוכנים כדי לאפשר לה לעבור ממש בסמוך ללקוחות ולאחר לכתה השוק חוזר מיד לפעילות רגילה. מעבר לרכבת החולפת, השוק עצמו הוא שוק מקומי תוסס, בו ניתן למצוא פירות, ירקות, מוצרי בשר, דגים, פירות ים ומאכלים תאילנדיים מסורתיים. החוויה יוצאת הדופן של הרכבת החולפת דרך השוק היא מראה בלתי נשכח אשר מומלץ מאוד לחוות לפחות פעם אחת.',
        },
        {
          subtitle: 'שמורת הקופים השוחים – חוויה טבעית יוצאת דופן',
          text: '<strong>מיקום:</strong> כפר Khlong Khon, כ-80 ק"מ מבנגקוק. <br /><strong>שעות פעילות:</strong> מידי יום, בהתאם לשעות פעילות הסירות.\n<br />שמורה זו ממוקמת באזור של יערות מנגרובים רחבי ידיים ובמרכזה נהר הנשפך למפרץ תאילנד. הקופים החיים באזור פיתחו יכולת ייחודית לשחות אל המבקרים המגיעים בסירות, מתוך תקווה לקבל מהם אוכל. החווייה מספקת הצצה מרתקת להתנהגותם של הקופים ולחיים באקוסיסטם של יערות המנגרובים. מומלץ להביא בננות להאכלת הקופים, אך יש להיזהר מפניית יתר שלהם ולמנוע מהם לטפס על הסירה או ליצור מגע ישיר.',
        },
      ],
    },
    {
      title: 'הדרכה לתכנון הטיול',
      type: 'sub-headers',
      description:
        'לטיול מוצלח לשווקים ולאטרקציות הסמוכות לבנגקוק יש להיערך מראש. להלן המלצות לתכנון והדרכה:',
      content: [
        {
          subtitle: 'מסלול מומלץ לטיול יום מבנגקוק',
          text: 'יציאה מבנגקוק בשעות הבוקר המוקדמות – מומלץ לשכור רכב פרטי לנהיגה עצמית או רכב + נהג או להצטרף לטיול מאורגן.\nביקור בשוק הצף דמנואן סאדואק – חוויית שייט וצפייה בפעילות המסחר התוססת.\nביקור בשוק הרכבת מאקלונג – נסו להגיע בשעה המתאימה כדי לצפות ברכבת עוברת דרך השוק.\nארוחת צהריים באמפאווה וביקור בשוק הצף המקומי (במידה והטיול נערך בסוף שבוע).\nסיור בשמורת הקופים השוחים – חווייה ייחודית בטבע.\nחזרה לבנגקוק בשעות הערב.',
        },
        {
          subtitle: 'טיפים לטיול מוצלח',
          text: '<strong>שעת יציאה מומלצת:</strong> מוקדם בבוקר (06:00-07:00) כדי להספיק לבקר בכל האתרים.\n<br /><strong>מה להביא:</strong> קרם הגנה, כובע, מים, בננות להאכלת הקופים, מצלמה.\n<br /><strong>אמצעי תחבורה: </strong>רכב פרטי, מונית או טיול מאורגן.\n<br /><strong>עלויות: </strong>שייט בסירה בשוק הצף עולה כ -200 - 400  באט לאדם, בהתאם למסלול ולסוג הסירה.\n<br />עדיפות לטיול בסופי שבוע, אז גם המקומיים מבקרים במקומות אלו והינם שוקקי חיים ומאפשרים את החווייה הטובה ביותר עבור אתרים אלו.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        "בשורה התחתונה, טיול יום לשווקים המיוחדים הסמוכים לבנגקוק, מאפשר הצצה לעולם הצבעוני והמרתק של תאילנד. ניתן ליהנות מחוויה מסורתית בשווקים הצפים, להתרגש משוק הרכבת הדינמי ולסיים את היום במפגש בלתי נשכח עם הקופים השוחים.\nבין אם הינכם שוהים בבנגקוק או בדרככם לקנצ'נבורי או הואה הין – זהו מסלול מומלץ לכל חובבי התרבות, הקולינריה והאטרקציות הייחודיות של תאילנד!",
      type: 'text',
      isBold: true,
    },
  ],
};
